export default __webpack_public_path__ + "static/media/trx.8c9b89ef.svg";